import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Switch,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from "@mui/icons-material/Settings";
import toast from "react-hot-toast";
import HomeScreenParentTable from "./HomeScreenParentTable ";
import { axiosConfig } from "../../../axios/axiosConfig";
import SelectPlanPopup from "./SelectPlanPopup";
import AppBlockingDialog from "./AppBlockingDialog";
import AppVersionForm from "./AppVersionForm";
import AppConfigTable from "./AppConfigTable";
const AppConfiguration = () => {
  const [parentComponent, setParentComponent] = useState([]);
  const [layoutData, setLayoutData] = useState({});
  const [layoutLoading, setLayoutLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState({
    key: "",
    component_name: "",
    component_parent: "",
    order: "",
    is_active: true,
  });
  const [editId, setEditId] = useState(null);
  const [planPopupOpen, setPlanPopupOpen] = useState(false);
  const [selectedRowForPlans, setSelectedRowForPlans] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [appVersionModalOpen, setAppVersionModalOpen] = useState(false);
  const [blockDialogOpen, setBlockDialogOpen] = useState(false);
  const [selectedRowForBlock, setSelectedRowForBlock] = useState(null);
  const [blockLoading, setBlockLoading] = useState(false);
  const [taggedPlansMap, setTaggedPlansMap] = useState({});

  const handleOpenBlockDialog = (row) => {
    setSelectedRowForBlock(row);
    setBlockDialogOpen(true);
  };

  const handleCloseBlockDialog = () => {
    setBlockDialogOpen(false);
    setSelectedRowForBlock(null);
  };

  const handleConfirmBlock = async (row, selectedPlanIds) => {
    setBlockLoading(true);
    try {
      const res = await axiosConfig({
        method: "post",
        url: "/home/block-home-screen-item/",
        data: { id: row.id, plan_ids: selectedPlanIds },
      });
      const msg = res?.data?.message || res?.data?.response || "Item blocked successfully!";
      toast.success(msg);
      handleCloseBlockDialog();
      fetchLayoutData();
    } catch (e) {
      const errMsg =
        e.response?.data?.message ||
        e.response?.data?.response ||
        e.response?.data?.detail ||
        e.message ||
        "Failed to block item";
      toast.error(errMsg);
    } finally {
      setBlockLoading(false);
    }
  };

  const fetchParents = async () => {
    setLoading(true);
    try {
      const response = await axiosConfig({
        method: "get",
        url: "/home/get-all-home-screen-parent",
      });

      setParentComponent(response?.data?.data || []);
    } catch (error) {
      const errMsg =
        error?.response?.data?.response ||
        error.message ||
        "Something went wrong";
      toast.error(errMsg);
    } finally {
      setLoading(false);
    }
  };

  const fetchLayoutData = async () => {
    setLayoutLoading(true);
    try {
      const response = await axiosConfig({
        method: "get",
        url: "/home/homescreen-ui-layout",
      });

      setLayoutData(response?.data?.data || []);
    } catch (error) {
      const errMsg =
        error?.response?.data?.response ||
        error.message ||
        "Failed to fetch layout data.";
      toast.error(errMsg);
    } finally {
      setLayoutLoading(false);
    }
  };
  useEffect(() => {
    fetchParents();
    fetchLayoutData();
  }, []);

  const handleOpen = () => {
    setFormData({
      key: "",
      component_name: "",
      component_parent: "",
      order: "",
      is_active: true,
    });
    setEditId(null);
    setOpenModal(true);
  };
  const handleOpenModal = (row = null) => {
    if (row) {
      setFormData({
        key: row.key,
        component_name: row?.name,
        component_parent: row.component_parent,
        order: row.order,
        is_active: !!row.is_active,
      });
      setEditId(row.id);
    } else {
      setFormData({
        key: "",
        component_name: "",
        component_parent: "",
        order: "",
        is_active: true,
      });
      setEditId(null);
    }
    setOpenModal(true);
  };
  const handleSubmit = async () => {
    if (formData.order < 0) {
      toast.error("Order value cannot be negative.");
      return;
    }
    const payload = {
      key: formData.key,
      component_name: formData.component_name,
      component_parent: formData.component_parent,
      order: formData.order,
      is_active: Boolean(formData.is_active), // ensure boolean
    };
    try {
      if (editId) {
        // Update
        await axiosConfig({
          method: "patch",
          url: `/home/homescreen-ui-layout/${editId}/`,
          data: payload,
        });
        toast.success("Component updated successfully!");
      } else {
        // Create
        await axiosConfig({
          method: "post",
          url: `/home/homescreen-ui-layout`,
          data: payload,
        });
        toast.success("Component created successfully!");
      }
      fetchLayoutData();
      setOpenModal(false);
    } catch (error) {
      const errMsg =
        error?.response?.data?.response ||
        error.message ||
        "Something went wrong. Please try again.";
      toast.error(errMsg);
    }
  };

  const handleOpenPlanPopup = (row) => {
    setSelectedRowForPlans(row);
    setPlanPopupOpen(true);
  };

  const handleClosePlanPopup = () => {
    setPlanPopupOpen(false);
    setSelectedRowForPlans(null);
  };
  const handleAfterPlanSave = async () => {
    // refresh UI if needed, e.g., re-fetch layout or other user data
    await fetchLayoutData();
    toast.success("Plans updated.");
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      {/* Page Header */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(4,52,58,0.3)",
          p: "20px 28px",
          mb: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <SettingsIcon sx={{ color: "#fff", fontSize: 32 }} />
          <Box>
            <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
              App Configuration
            </Typography>
            <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: "13px" }}>
              Manage home screen layout components
            </Typography>
          </Box>
        </Box>
        <Button
          onClick={handleOpen}
          sx={{
            background: "linear-gradient(135deg, #016551, #014d3d)",
            color: "#fff",
            fontWeight: 600,
            borderRadius: "8px",
            px: 3,
            boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
            "&:hover": { background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)" },
          }}
        >
          Customise Your App
        </Button>
      </Box>

      {/* Tabs + Content Card */}
      <Box
        sx={{
          background: "#fff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
          overflow: "hidden",
        }}
      >
        {layoutLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress sx={{ color: "#016551" }} />
          </Box>
        ) : (
          <>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                background: "#04343a",
                minHeight: 46,
                "& .MuiTab-root": {
                  color: "rgba(255,255,255,0.6)",
                  fontWeight: 600,
                  fontSize: "13px",
                  minHeight: 46,
                  textTransform: "none",
                  px: 3,
                },
                "& .Mui-selected": { color: "#fff !important" },
                "& .MuiTabs-indicator": { backgroundColor: "#1db954", height: 3 },
                "& .MuiTabScrollButton-root": { color: "rgba(255,255,255,0.6)" },
              }}
            >
              {Object.keys(layoutData).map((parentName) => (
                <Tab key={parentName} label={parentName} />
              ))}
              <Tab label="Android Config" />
            </Tabs>

            <Box sx={{ p: 2 }}>
              {Object.entries(layoutData).map(([parentName, items], index) =>
                activeTab === index ? (
                  <HomeScreenParentTable
                    key={parentName}
                    parentName={parentName}
                    data={items}
                    onEdit={handleOpenModal}
                    onOpenPlanPopup={handleOpenPlanPopup}
                    onAppBlock={handleOpenBlockDialog}
                  />
                ) : null
              )}
              {activeTab === Object.keys(layoutData).length && (
                <Box>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                    <Button
                      onClick={() => setAppVersionModalOpen(true)}
                      sx={{
                        background: "linear-gradient(135deg, #016551, #014d3d)",
                        color: "#fff",
                        fontWeight: 600,
                        borderRadius: "8px",
                        px: 3,
                        boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
                        "&:hover": { background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)" },
                      }}
                    >
                      Update App Version Config
                    </Button>
                  </Box>
                  <AppConfigTable />
                </Box>
              )}
            </Box>
          </>
        )}
      </Box>
      {/* form for customise app  */}
      <Dialog open={openModal} fullWidth maxWidth="sm">
        <DialogTitle
          sx={{
            background: "#04343a",
            color: "#fff",
            fontWeight: 700,
            fontSize: "16px",
            py: "14px",
            px: "20px",
          }}
        >
          {editId ? "Edit Component" : "Add Component"}
          <IconButton
            onClick={() => setOpenModal(false)}
            sx={{ position: "absolute", right: 8, top: 8, color: "rgba(255,255,255,0.7)", "&:hover": { color: "#fff" } }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            overflowX: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": { display: "none" },
            pt: "16px !important",
          }}
        >
          <TextField
            label="Key"
            value={formData.key}
            onChange={(e) => setFormData({ ...formData, key: e.target.value })}
            fullWidth
            margin="normal"
            InputProps={{ readOnly: !!editId }}
          />
          <TextField
            label="Component Name"
            value={formData.component_name}
            onChange={(e) => setFormData({ ...formData, component_name: e.target.value })}
            fullWidth
            margin="normal"
          />
          <TextField
            select
            label="Parent Component"
            value={formData.component_parent}
            onChange={(e) => setFormData({ ...formData, component_parent: e.target.value })}
            fullWidth
            margin="normal"
          >
            {parentComponent.map((parent) => (
              <MenuItem key={parent.id} value={parent.id}>
                {parent.component_name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            label="Order"
            type="number"
            value={formData.order}
            onChange={(e) => setFormData({ ...formData, order: parseInt(e.target.value) })}
            fullWidth
            margin="normal"
          />
          <Box display="flex" alignItems="center" gap={1} mt={2}>
            <Switch
              checked={!!formData.is_active}
              onChange={(e) => setFormData((prev) => ({ ...prev, is_active: e.target.checked }))}
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": { color: "#016551" },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#016551" },
              }}
            />
            <Typography sx={{ fontSize: "14px", color: "#1e293b" }}>Active</Typography>
          </Box>
          <Box mt={3}>
            <Button
              onClick={handleSubmit}
              sx={{
                background: "linear-gradient(135deg, #016551, #014d3d)",
                color: "#fff",
                fontWeight: 600,
                borderRadius: "8px",
                px: 3,
                boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
                "&:hover": { background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)" },
              }}
            >
              {editId ? "Update" : "Create"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <SelectPlanPopup
        open={planPopupOpen}
        onClose={handleClosePlanPopup}
        onSaved={handleAfterPlanSave}
        screenRow={selectedRowForPlans}
      />
      <AppBlockingDialog
        open={blockDialogOpen}
        onClose={handleCloseBlockDialog}
        row={selectedRowForBlock}
        defaultSelected={selectedRowForBlock ? (taggedPlansMap[selectedRowForBlock.id] || []) : []}
        onSuccess={(selectedCodes) => {
          if (selectedRowForBlock) {
            setTaggedPlansMap((prev) => ({ ...prev, [selectedRowForBlock.id]: selectedCodes }));
          }
          fetchLayoutData();
        }}
      />
      {/* App Version Configuration Modal */}
      <Dialog
        open={appVersionModalOpen}
        fullWidth
        maxWidth="md"
        onClose={() => setAppVersionModalOpen(false)}
      >
        <DialogTitle
          sx={{
            background: "#04343a",
            color: "#fff",
            fontWeight: 700,
            fontSize: "16px",
            py: "14px",
            px: "20px",
          }}
        >
          App Version Config
          <IconButton
            onClick={() => setAppVersionModalOpen(false)}
            sx={{ position: "absolute", right: 8, top: 8, color: "rgba(255,255,255,0.7)", "&:hover": { color: "#fff" } }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <AppVersionForm />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default AppConfiguration;
